export default class ConvictionInfo {
   constructor(
      {
         date = '',
         code = '',
         points = '',
         fines = '',
         banLengthInMonths = '',
         wasDriverBreathalysed = '',
         wasOffenceAccidentRelated = '',
         otherCode = ''
      }
   ) {
      
      this.date = date;
      this.code = code;
      this.points = points;
      this.fines = fines;
      this.banLengthInMonths = banLengthInMonths;
      this.wasDriverBreathalysed = wasDriverBreathalysed;
      this.wasOffenceAccidentRelated = wasOffenceAccidentRelated;
      
      this.otherCode = otherCode;
      
   }
}